import type { InputHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
}

export function Input({
  id,
  label,
  hint,
  error,
  className,
  ...rest
}: InputProps) {
  const inputId = id ?? rest.name;
  return (
    <div className={styles.field}>
      {label ? (
        <label className={styles.fieldLabel} htmlFor={inputId}>
          {label}
        </label>
      ) : null}
      <input
        id={inputId}
        className={cn(styles.control, error && styles.controlError, className)}
        aria-invalid={error ? true : undefined}
        {...rest}
      />
      {error ? <div className={styles.fieldError}>{error}</div> : null}
      {!error && hint ? <div className={styles.fieldHint}>{hint}</div> : null}
    </div>
  );
}
